module.exports = __webpack_public_path__ + "img/tm.d55963e2.svg";